module.exports = __webpack_public_path__ + "static/flowers-b323035064ff6f7990f287201e449d7a.jpg";